module.exports = __webpack_public_path__ + "img/free-icon-technical-drawing-1321042.42b7f5b3.png";